import { render, staticRenderFns } from "./StorySection.vue?vue&type=template&id=284d0f71&scoped=true"
import script from "./StorySection.vue?vue&type=script&lang=js"
export * from "./StorySection.vue?vue&type=script&lang=js"
import style0 from "./StorySection.vue?vue&type=style&index=0&id=284d0f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284d0f71",
  null
  
)

export default component.exports